import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ICountryModel } from '@fi-shared/fi-contacts/fi-countries-select/country';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';

@Component({
    selector: 'fi-countries-menu',
    template: `
        <button mat-button type="button" class="countries-menu-trigger" [matMenuTriggerFor]="countriesMenu">
            <div
                class="country-flag-icon"
                [style.background-image]="getSelectedCountryFlagImgUrl(selectedCountry.IsoTwoCode)"
            ></div>
        </button>

        <mat-menu #countriesMenu="matMenu" class="countries-menu fi-rounded-menu">
            <ng-template matMenuContent>
                <fi-menu-item-search
                    [items]="countries"
                    [isTextFieldLabelType]="true"
                    displayProperty="TextId"
                    [isFilteredItemsWrapped]="true"
                    [getAdditionalTextFn]="getAdditionalTextFn"
                    [maxItemsToShow]="5"
                    (onItemSelect)="onCountrySelect($event)"
                >
                    <ng-template #menuItemPrefixContent let-country>
                        <div
                            class="country-flag-icon"
                            [style.background-image]="getSelectedCountryFlagImgUrl(country.IsoTwoCode)"
                        ></div>
                    </ng-template>
                </fi-menu-item-search>
            </ng-template>
        </mat-menu>
    `,
    styleUrls: ['./fi-countries-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-countries-menu' },
    standalone: false,
})
export class FiCountriesMenuComponent {
    @Input() countries: ICountryModel[] = [];
    @Input() selectedCountry: ICountryModel = {} as ICountryModel;
    @Output() selectedCountryChange: EventEmitter<ICountryModel> = new EventEmitter();

    constructor(private fiCountryHelperService: FiCountryHelperService) {}

    getAdditionalTextFn: (country: ICountryModel) => string = (country: ICountryModel) => {
        return `(${country.CountryCode})`;
    };

    getSelectedCountryFlagImgUrl(IsoTwoCode: string): string {
        return this.fiCountryHelperService.getCountryFlagUrl(IsoTwoCode);
    }

    onCountrySelect(newSelectedCountry: ICountryModel): void {
        this.selectedCountry = newSelectedCountry;
        this.selectedCountryChange.emit(this.selectedCountry);
    }
}
